"use client";

import { useEffect } from "react";
import { usePathname } from "next/navigation";
import { refreshNativeStatusBarMeta } from "@/lib/status-bar-meta";

export function NativeStatusBarMetaSync() {
  const pathname = usePathname();

  useEffect(() => {
    if (document.documentElement.dataset.awardPartyNativeShell !== "true") {
      return;
    }
    refreshNativeStatusBarMeta(document);
  }, [pathname]);

  return null;
}
